import e from"react";const t=({baseStyles:t,children:a})=>e.createElement("div",{className:"c-cartoon-label",style:t},e.createElement("div",{className:"c-cartoon-label__content"},a));export{t as Label};
//# sourceMappingURL=Label.js.map
